<template>
  <div id="home">
    <nav-bar @loginClick="loginClick"></nav-bar>
    <div class="content" v-if="!isLogin">
      <select-one></select-one>
      <select-two></select-two>
      <select-third></select-third>
      <select-five></select-five>
      <select-six></select-six>
    </div>
  </div>
</template>

<script>
import navBar from "./components/nav";
import selectOne from "./components/selection-1";
import selectTwo from "./components/selection-2";
import selectThird from "./components/selection-3";
import selectFour from "./components/selection-4";
import selectFive from "./components/selection-5";
import selectSix from './components/selection-6.vue'
export default {
  name: "home",
  components: {
    navBar,
    selectOne,
    selectTwo,
    selectThird,
    selectFour,
    selectFive,
    selectSix
  },
  data() {
    return {
      isLogin: false
    };
  },
  methods: {
    loginClick(value) {
      this.isLogin = value;
    }
  },
  mounted() {
    if (this.$route.query.login) {
      this.$router.push({
        path:'/login',
        query:this.$route.query
      })
    }
  }
};
</script>
<style lang="scss" scoped>
#home {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: auto;
  height: auto;
  overflow: hidden;
  background: RGBA(255, 255, 255, 1);
  .swiper {
    height: 100%;
    height: 100%;
  }
}
</style>
